/* eslint-disable @typescript-eslint/naming-convention */
export enum LipstickType {
	"スティック",
	"リキッドルージュ",
	"リップグロス",
	"ティント",
	"その他",
}
